import apiService from '../../../repositories/apiService';

export default {
    getAllMyBibleStudies({ commit }, location) {
        commit('setLoading', true);
        const payload = {
            url: '/bible_studies/paginated-filtered-bible-studies',
            filter: 'allMyBibleStudies',
            location
        };
        return this.dispatch(
            'BibleStudies/Pagination/paginatedFetchWithPayload',
            payload
        )
            .then((response) => {
                commit('setBibleStudies', response.data.data);
                commit('setError', '');
                commit('setLoading', false);
            })
            .catch((error) => {
                commit('setError', error);
                commit('setLoading', false);
            });
    },
    getAllViewableBibleStudies({ commit }, location) {
        commit('setLoading', true);
        const payload = {
            url: '/bible_studies/paginated-filtered-bible-studies',
            filter: 'allViewableBibleStudies',
            location
        };
        return this.dispatch(
            'BibleStudies/Pagination/paginatedFetchWithPayload',
            payload
        )
            .then((response) => {
                commit('setBibleStudies', response.data.data);
                commit('setError', '');
                commit('setLoading', false);
            })
            .catch((error) => {
                commit('setError', error);
                commit('setLoading', false);
            });
    },
    getMyActiveBibleStudies({ commit }, location) {
        commit('setLoading', true);
        const payload = {
            url: '/bible_studies/paginated-filtered-bible-studies',
            filter: 'myActiveBibleStudies',
            location
        };
        return this.dispatch(
            'BibleStudies/Pagination/paginatedFetchWithPayload',
            payload
        )
            .then((response) => {
                commit('setBibleStudies', response.data.data);
                commit('setError', '');
                commit('setLoading', false);
            })
            .catch((error) => {
                commit('setError', error);
                commit('setLoading', false);
            });
    },
    getViewableActiveBibleStudies({ commit }, location) {
        commit('setLoading', true);
        const payload = {
            url: '/bible_studies/paginated-filtered-bible-studies',
            filter: 'viewableActiveBibleStudies',
            location
        };
        return this.dispatch(
            'BibleStudies/Pagination/paginatedFetchWithPayload',
            payload
        )
            .then((response) => {
                commit('setBibleStudies', response.data.data);
                commit('setError', '');
                commit('setLoading', false);
            })
            .catch((error) => {
                commit('setError', error);
                commit('setLoading', false);
            });
    },
    getBibleStudyById(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .get(`/bible_studies/${payload.bibleStudyId}`)
                .then((response) => {
                    resolve(response);
                    state.commit('setBibleStudy', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    getBibleStudyParticipantsById(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .get(`/bible_studies/${payload.bibleStudyId}/participants`)
                .then((response) => {
                    resolve(response);
                    state.commit('setBibleStudyParticipants', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    getAllBibleStudyParticipantsById(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .get(`/bible_studies/${payload.bibleStudyId}/allParticipants`)
                .then((response) => {
                    resolve(response);
                    state.commit('setAllBibleStudyParticipants', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    if (payload.bibleStudyId) {
                        state.commit('setError', error);
                    }
                });
        });
    },
    getBibleStudyAttendancesById(state, payload) {
        state.commit('setLoading', true);
        return this.dispatch(
            'BibleStudies/BSAPagination/paginatedFetch',
            `/bible_studies/${payload.bibleStudyId}/attendances`
        )
            .then((response) => {
                state.commit('setBibleStudyAttendances', response.data.data);
                state.commit('setError', '');
                state.commit('setLoading', false);
            })
            .catch((error) => {
                state.commit('setError', error);
                state.commit('setLoading', false);
            });
    },
    storeNewBibleStudy(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .post('/bible_studies', payload)
                .then((response) => {
                    resolve(response.data.id);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    updateBibleStudy(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .put(`/bible_studies/${payload.bible_study_data.id}`, payload)
                .then((response) => {
                    // PUT request returns updated bible study
                    state.commit('setBibleStudy', response.data.data);
                    // GET updated list of bible study attendances
                    // which may be affected by the BS end date
                    state.dispatch(
                        'getBibleStudyAttendancesById',
                        { bibleStudyId: payload.bible_study_data.id }
                    );
                    // GET updated list of all bible study participants
                    // whose attendance rates may be affected by the BS end date
                    state.dispatch(
                        'getAllBibleStudyParticipantsById',
                        { bibleStudyId: payload.bible_study_data.id }
                    );
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    reopenBibleStudy(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .put(`/bible_studies/${payload.bibleStudyId}/reopen`, payload)
                .then((response) => {
                    // PUT request returns updated bible study
                    state.commit('setBibleStudy', response.data.data);
                    // GET updated list of bible study attendances
                    // which may be affected by the BS end date
                    state.dispatch(
                        'getBibleStudyAttendancesById',
                        { bibleStudyId: payload.bibleStudyId }
                    );
                    // GET updated list of all bible study participants
                    // whose attendance rates may be affected by the BS end date
                    state.dispatch(
                        'getAllBibleStudyParticipantsById',
                        { bibleStudyId: payload.bibleStudyId }
                    );
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error.message);
                });
        });
    },
    storeNewBibleStudyParticipant(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .post(`/bible_studies/${payload.participant_data.bible_study_id}/participants`, payload)
                .then((response) => {
                    // POST request returns list of active bible study participants
                    state.commit(
                        'setBibleStudyParticipants',
                        response.data.data
                    );
                    // GET updated list of all bible study participants
                    state.dispatch(
                        'getAllBibleStudyParticipantsById',
                        { bibleStudyId: payload.participant_data.bible_study_id }
                    );
                    // GET attendances which may be updated by participant injection
                    state.dispatch(
                        'getBibleStudyAttendancesById',
                        { bibleStudyId: payload.participant_data.bible_study_id }
                    );
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error.message);
                });
        });
    },
    removeBibleStudyParticipant(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .delete(`/bible_studies/${payload.participant_data.bible_study_id}/participants`, { data: payload })
                .then((response) => {
                    // DELETE request returns list of active bible study participants
                    state.commit(
                        'setBibleStudyParticipants',
                        response.data.data
                    );
                    // GET updated list of all bible study participants
                    state.dispatch(
                        'getAllBibleStudyParticipantsById',
                        { bibleStudyId: payload.participant_data.bible_study_id }
                    );
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    updateBibleStudyAttendance(state, payload) {
        state.commit('setLoading', true);
        return new Promise((resolve, reject) => {
            let route = `/bible_studies/${payload.attendance_data.bible_study_id}`;
            route = route.concat(`/attendances/${payload.attendance_data.id}`);
            payload.params = {};
            payload.params.page_size = state.state.BSAPagination.itemsPerPage;
            apiService
                .put(
                    route,
                    payload
                )
                .then((response) => {
                    // PUT request returns list of attendances
                    state.commit('setBibleStudyAttendances', response.data.data);
                    // GET bible study with updated reporting % / reports missing
                    state.dispatch(
                        'getBibleStudyById',
                        { bibleStudyId: payload.attendance_data.bible_study_id }
                    );
                    // GET bible study participants with updated attendance rates
                    state.dispatch(
                        'getAllBibleStudyParticipantsById',
                        { bibleStudyId: payload.attendance_data.bible_study_id }
                    );
                    state.state.BSAPagination.currentPage = 1;
                    state.commit('setError', '');
                    state.commit('setLoading', false);
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                    state.commit('setLoading', false);
                });
        });
    },
    getCancelReasons(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/list_items/cancel_reasons')
                .then((response) => {
                    state.commit('setCancelReasons', response.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    createBibleStudyAttendance(state, payload) {
        return new Promise((resolve, reject) => {
            apiService
                .get(`/bible_studies/${payload.bibleStudyId}/attendance`)
                .then((response) => {
                    state.commit('setBibleStudyAttendance', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    storeBibleStudyAttendance(state, payload) {
        payload.params = {};
        payload.params.page_size = state.state.BSAPagination.itemsPerPage;
        return new Promise((resolve, reject) => {
            apiService
                .post(`/bible_studies/${payload.bibleStudyId}/attendance`, payload)
                .then((response) => {
                    state.dispatch(
                        'getBibleStudyAttendancesById',
                        { bibleStudyId: payload.bibleStudyId }
                    );
                    state.commit('setError', '');
                    // GET bible study participants with updated attendance rates
                    state.dispatch(
                        'getAllBibleStudyParticipantsById',
                        { bibleStudyId: payload.bibleStudyId }
                    );
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    getEligibleLeaders(state) {
        return new Promise((resolve, reject) => {
            apiService
                .get('/bible_studies/eligibleLeaders')
                .then((response) => {
                    state.commit('setEligibleLeaders', response.data.data);
                    state.commit('setError', '');
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
    getEligibleParticipants(state, payload) {
        if (payload.bibleStudyId) {
            return new Promise((resolve, reject) => {
                apiService
                    .get(`/bible_studies/${payload.bibleStudyId}/eligibleParticipants`)
                    .then((response) => {
                        state.commit('setEligibleParticipants', response.data.data);
                        state.commit('setError', '');
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        state.commit('setError', error);
                    });
            });
        }
        return new Promise((resolve, reject) => {
            apiService
                .get('/bible_studies/eligibleParticipants')
                .then((response) => {
                    state.commit('setEligibleParticipants', response.data.data);
                    state.commit('setError', '');
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    },
};
